import React, { useState, useEffect } from "react";
import "../companylogo.css";
import { useAuth } from "../contexts/AuthContext";
import { NavLink } from "react-router-dom";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const CompanyLogo = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const { token, logout } = useAuth();

  const closeDropdown = () => {
    setShowDropdown(false);
  };

  useEffect(() => {
    window.addEventListener("click", closeDropdown);

    return () => {
      window.removeEventListener("click", closeDropdown);
    };
  }, []);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      if (!token) {
        console.error("No token available. Please log in again.");
        return;
      }

      try {
        const response = await axios.get(`${BASE_URL}/companies/details`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data && response.data.name) {
          setCompanyName(response.data.name);
        }
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };

    fetchCompanyDetails();
  }, [token]);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setShowDropdown(!showDropdown);
  };

  const handleLogout = () => {
    logout();
    closeDropdown();
  };

  return (
    <div className="company-logo">
      {companyName ? (
        <div
          className="company-initial"
          style={{
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#5e95ff",
            color: "#fff",
            borderRadius: "50%",
            fontSize: "24px",
            fontWeight: "bold",
          }}
        >
          {companyName.charAt(0).toUpperCase()}
        </div>
      ) : (
        <img
          src="./static/images/faviconv2.png"
          style={{ width: "40px", height: "40px" }}
          alt="Company Logo"
        />
      )}
      <b>
        <span
          style={{ fontSize: "16px", marginLeft: "5px", cursor: "pointer" }}
          onClick={toggleDropdown}
        >
          {companyName}
          {companyName && " "}
          {companyName && <i className="fa fa-angle-down"></i>}
        </span>
      </b>
      {showDropdown && (
        <div className="dropdown-card" onClick={(e) => e.stopPropagation()}>
          <div className="card">
            <ul>
              <NavLink to="/account">
                <li>Account</li>
              </NavLink>
                <NavLink to="/funds">
                <li>Funds</li>
              </NavLink>
              <NavLink to="/billing">
                <li>Billing</li>
              </NavLink>
              <NavLink to="#">
                <li onClick={handleLogout}>Log out</li>
              </NavLink>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyLogo;
